import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './HomePage'; // 确保路径正确
import SharedNote from './SharedNote';
import RichTextEditor from './RichTextEditor';
import MailDetail from './MailDetail';
import LoginPage from './loginPage';
import { AuthProvider } from './AuthContext';
import DoorOpen from './Dooropen';
import WordList from './WordList';
import WordEdit from './WordEdit';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/homePage" element={<HomePage />} />
          <Route path="/sharedNote" element={<SharedNote />} />
          <Route path="/richTextEditor" element={<RichTextEditor />} />
          <Route path="/mailDetail" element={<MailDetail />} />
          <Route path="/DoorOpen" element={<DoorOpen />} />
          <Route path="/wordList" element={<WordList />} />
          <Route path="/wordEdit" element={<WordEdit />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App; // 确保导出了 App 组件